import type { LatLng } from "@strava/feature-global-wasm-mre";
import type { Camera, CameraMargins } from "@strava/mre";

import { logError } from "../../utils/sentry";

const FOLLOW_MARGINS: CameraMargins = { top: 0, right: 0, bottom: 0, left: 0 };
const TRANSLATE_DURATION_FACTOR = 1.2;

export function isValidLatLng(point: LatLng | null): point is LatLng {
  if (!point) return false;
  const [lat, lng] = point;
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}

export function panCameraTo(camera: Camera, latLng: LatLng): void {
  const [lat, lng] = latLng;
  try {
    camera.translateTo(
      { latitude: lat, longitude: lng },
      TRANSLATE_DURATION_FACTOR,
      FOLLOW_MARGINS,
      undefined
    );
  } catch (error) {
    logError(error);
  }
}
